var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2398_61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8 1.44772 8.44772 1 9 1H23C23.5523 1 24 1.44772 24 2C24 2.55228 23.5523 3 23 3H9C8.44772 3 8 2.55228 8 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4474 17.1055C15.9414 17.3525 16.1416 17.9532 15.8946 18.4472L13.8946 22.4472C13.6477 22.9412 13.047 23.1414 12.553 22.8944C12.059 22.6474 11.8588 22.0467 12.1058 21.5528L14.1058 17.5528C14.3528 17.0588 14.9535 16.8586 15.4474 17.1055Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.553 17.1055C18.047 16.8586 18.6477 17.0588 18.8946 17.5528L20.8946 21.5528C21.1416 22.0467 20.9414 22.6474 20.4474 22.8944C19.9535 23.1414 19.3528 22.9412 19.1058 22.4472L17.1058 18.4472C16.8588 17.9532 17.059 17.3525 17.553 17.1055Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15.5523 8 16 8.44772 16 9V11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H15C14.4477 13 14 12.5523 14 12V9C14 8.44772 14.4477 8 15 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23821 2.35219C1.42821 2.12876 1.70671 2 2.00001 2H5.00001C5.43044 2 5.81258 2.27543 5.94869 2.68377L6.72077 5H17C20.8523 5 24 8.14772 24 12C24 15.8523 20.8523 19 17 19H15C11.1477 19 8.00001 15.8523 8.00001 12V10H4.70001C3.18603 10 2.0054 8.92598 1.71943 7.49612C1.71707 7.48434 1.71493 7.47253 1.713 7.46068L1.013 3.16068C0.965875 2.87119 1.04821 2.57562 1.23821 2.35219ZM3.17596 4L3.68374 7.11923C3.80218 7.67987 4.21836 8 4.70001 8H9.00001C9.55229 8 10 8.44772 10 9V12C10 14.7477 12.2523 17 15 17H17C19.7477 17 22 14.7477 22 12C22 9.25229 19.7477 7 17 7H6.00001C5.56958 7 5.18744 6.72457 5.05132 6.31623L4.27925 4H3.17596Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 19C23.5523 19 24 19.4477 24 20C24 21.6523 22.6523 23 21 23H9C8.44772 23 8 22.5523 8 22C8 21.4477 8.44772 21 9 21H21C21.5477 21 22 20.5477 22 20C22 19.4477 22.4477 19 23 19Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2398_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.3d15db11824b531ad29505806a798188.svg";
export { ForwardRef as ReactComponent };